export const SINGLE_LINE_TEXT = 'SingleLineText'
export const RICH_TEXT = 'RichText'
export const CHECKBOX_LIST = 'CheckboxList'
